<template>
  <content-panel>
    <table-panel ref="tablePanel">
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        highlight-current-row
        border
        :data="tableData"
        :height="maxTableHeight"
      >
        <el-table-column prop="id" label="序号" align="center" width="80"></el-table-column>
        <el-table-column prop="startTime" label="对账周期时间" show-overflow-tooltip width="300">
          <template slot-scope="{row}">
            {{row.startTime ? row.startTime + ' - ' + row.endTime : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="total" label="总对账订单条数" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sumTotal" label="已对账订单条数" align="center"></el-table-column>
        <el-table-column prop="status" label="对账状态" align="center">
          <template slot-scope="scope">
            {{ statusText[scope.row.status] || "" }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="对账结果" align="center">
          <template slot-scope="scope">
            <span :style="`${scope.row.statusString == '异常' ? 'color: red' : ''}`">{{ scope.row.statusString }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createName" label="操作人" align="center"></el-table-column>
        <el-table-column label="操作" class-name="action-column" align="center">
          <template v-slot="scope">
            <el-button
              type="text"
              size="small"
              v-if="scope.row.statusString == '异常'"
              @click="handleAdd(scope.row, 3)"
            >
              下载异常报表
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
     
      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      query: {},
      statusText: {
        0: "对账中",
        1: "对账完成",
        2: "对账完成",
      },
      status2Text: {
        0: "",
        1: "核对金额无异，数据无异",
        2: "核对金额有异，数据异常",
      },
    };
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.query,
        },
      };
      this.$api.dataReport.reconciliationPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleAdd(row, actionType) {
      let params = {
        reconciliationId: row.id
      };
      this.$api.common.doExport("diffPageList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  created() {
    this.query = this.$route.query
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  // margin: 0 10px;
  // background: #fff;
  .head-box {
    margin: 0 15px;
    margin-top: 5px;
    padding: 10px;
    border-radius: 5px;
    background: #fff;
  }
  .date-input  {
    width 220px !important
  }
  .data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      padding: 6px 0;
      border-bottom: 1px solid #ccc;
    }
    .number {
      text-align: center;
      padding: 6px 0;
    }
  }
}
</style>
